/* eslint-disable camelcase */ /* TODO: should the API be camelCase? */
import React, { useEffect, useMemo } from 'react'

import { track } from 'lib/analytics'
import { BannerStrip } from 'baby-design'

interface AdContent {
  title: string
  cta_url?: string
  cta_text?: string
}

interface PlacementAd {
  ad_id: string
  content_type: string
  content: AdContent
}

interface AdProps {
  ad: PlacementAd
  unitId: string
}

export interface PlacementsGlobalBannerProps {
  unitId: string
  initialAds?: PlacementAd[]
}

const Ad: React.FC<AdProps> = ({ unitId, ad }) => {
  const trackingContext = useMemo(
    () => ({
      eventLocation: track.EventLocation.WEB_TOP_NAV,
      adId: ad.ad_id,
      adTitle: ad.content.title,
      adUnitId: unitId,
      adCtaText: ad.content.cta_text || '',
    }),
    [ad, unitId]
  )

  useEffect(() => {
    track.targetedPlacementViewed(trackingContext)
  }, [trackingContext])

  const handleCtaClick = () => {
    track.targetedPlacementClicked(trackingContext)
  }

  const { ad_id, content } = ad
  return (
    <span data-testid={`adContent-${ad_id}`} key={`adContent-${ad_id}`}>
      {content.title}
      {content.cta_url && (
        <>
          {' '}
          <a href={content.cta_url} onClick={handleCtaClick}>
            {content.cta_text}
          </a>
        </>
      )}
    </span>
  )
}

const PlacementsGlobalBanner: React.FC<PlacementsGlobalBannerProps> = ({
  unitId,
  initialAds,
}) => {
  const ads = initialAds // TODO: dynamic ads via useQuery/hook

  if (!ads || ads.length === 0) {
    return null
  }

  const adIndex = 0 // TODO: multiple rotating ads

  // TODO: dismissable banner
  return (
    <BannerStrip data-testid={`globalBanner-${unitId}`}>
      <Ad ad={ads[adIndex]} unitId={unitId} />
    </BannerStrip>
  )
}

export default PlacementsGlobalBanner
